export default __webpack_public_path__ + "static/media/CSIT.02918a25.PNG";